import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Form, Card, Button, Spinner } from "react-bootstrap";
import Joi from "joi-browser";
import FormComponent from "./common/formComponent";
import { resetPassword } from "../services/authService";

class SetNewPassword extends FormComponent {
  state = {
    data: { email: this.props.verificationToken.email, newPassword: "", confirmNewPassword: "" },
    errors: {},
    isResetSuccessful: false,
    processing: false,
  };

  schema = {
    email: Joi.string().email().required().label("Email"),
    newPassword: Joi.string().required().label("New Password"),
    confirmNewPassword: Joi.string().required().label("Confirm New Password"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      await resetPassword(this.state.data);

      this.setState({ isResetSuccessful: true });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  render() {
    const { data, errors, processing, isResetSuccessful } = this.state;

    return (
      <Card className="col-md-4 mt-5 mx-auto" id="login">
        <Card.Body>
          {!isResetSuccessful && (
            <Form onSubmit={this.handleSubmit}>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  name="newPassword"
                  onChange={this.handleChange}
                  value={data.newPassword}
                  size="sm"
                  type="password"
                  placeholder="New Password"
                />
                {errors.password && <span className="text-danger">{errors.password}</span>}
              </Form.Group>

              <Form.Group controlId="formBasicPassword">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  name="confirmNewPassword"
                  onChange={this.handleChange}
                  value={data.confirmNewPassword}
                  size="sm"
                  type="password"
                  placeholder="Confirm New Password"
                />
                {errors.password && <span className="text-danger">{errors.password}</span>}
              </Form.Group>

              <Button disabled={this.validate() || processing} type="submit" className="main-color-bg" block>
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Reset Password
              </Button>
            </Form>
          )}

          {isResetSuccessful && (
            <span>
              Your password reset request is successful. You can now <Link to="/login">login</Link> to you account with
              your new password.
            </span>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default SetNewPassword;
